// ClientesRoutesXL - Sprint 44 Fase 3 Vista 2.
// Reemplaza el router legacy src/modules/clientes/routes.jsx.
// Mismo patron: index (list), /nuevo, /:id. Montado desde AppRoutes.
import { Routes, Route } from 'react-router-dom';
import ClientesListXL from './ClientesListXL';
import ClienteFormXL from './ClienteFormXL';

export default function ClientesRoutesXL() {
  return (
    <Routes>
      <Route index element={<ClientesListXL />} />
      <Route path="nuevo" element={<ClienteFormXL />} />
      <Route path=":id" element={<ClienteFormXL />} />
    </Routes>
  );
}
